/**
 * Nosto-Config.js
 *
 * Contiene las configuraciones compartidas por los módulos de Nosto,
 * incluyendo las definiciones de filtros, grupos de colores, etiquetas
 * y reglas que pueden utilizar tanto PLP como Search.
 */

(function initializeNostoConfig(global) {
    "use strict";

    const NOSTO_COLOR_GROUPS = {
        AMARILLO: [
            "AMARILLO",
            "AMARILLO COMBO",
            "AMARILLO NEON",
            "AMARILLO OBSCURO",
            "AMARILLO PASTEL",
            "MANGO",
            "MOSTAZA",
            "MOSTAZA COMBO",
            "MOSTAZA OBSCURO",
        ],

        AZUL: [
            "ACID LIGHT",
            "ACID MEDIO",
            "ACID WASH",
            "AZUL",
            "AZUL BRILLANTE",
            "AZUL CIELO",
            "AZUL COMBO",
            "AZUL ELECTRICO",
            "AZUL PASTEL",
            "AZUL PATO",
            "AZUL PITUFO",
            "AZUL REY",
            "AZUL REY COMBO",
            "BLEACHED",
            "DARK WASH",
            "INDIGO",
            "LIGHT WASH",
            "MARINO",
            "MARINO COMBO",
            "MEDIUM WASH",
            "STONE",
            "STONE LIGHT",
            "STONE MEDIO",
        ],

        BEIGE: [
            "ARENA",
            "BEIGE",
            "CREMA",
            "HUESO",
            "HUESO COMBO",
            "NUDE",
        ],

        BLANCO: [
            "BLANCO",
            "BLANCO COMBO",
            "TRANSPARENTE",
        ],

        CAFÉ: [
            "AMBAR",
            "BRONCE",
            "CAFE",
            "CAFE COMBO",
            "CAFE OBSCURO",
            "CAMELLO",
            "CHOCOLATE",
            "COBRE",
            "GREIGE",
            "KHAKI",
            "KHAKI COMBO",
            "TAN",
            "TAUPE",
        ],

        GRIS: [
            "GRIS",
            "GRIS CLARO",
            "GRIS COMBO",
            "GRIS JASPE",
            "GRIS OBSCURO",
            "HEMATITA",
            "PETROLEO",
        ],

        METÁLICOS: [
            "IRIDISCENTE",
            "ORO",
            "ORO COMBO",
            "ORO ROSA",
            "PLATA",
            "PLATA COMBO",
        ],

        MORADO: [
            "LAVANDA",
            "LILA",
            "LILA OBSCURO",
            "MALVA",
            "MORADO",
            "MORADO BRILLANTE",
            "MORADO COMBO",
            "UVA",
        ],

        MULTICOLOR: [
            "MULTICOLOR",
            "MULTICOLOR B&N",
            "MULTICOLOR BRILLANTE",
            "MULTICOLOR NEON",
            "MULTICOLOR OTOÑAL",
            "MULTICOLOR PASTEL",
        ],

        NARANJA: [
            "CORAL",
            "CORAL COMBO",
            "DURAZNO",
            "MANDARINA",
            "NARANJA",
            "NARANJA BRILLANTE",
            "NARANJA COMBO",
            "NARANJA NEON",
            "NARANJA OBSCURO",
        ],

        NEGRO: [
            "ACID DARK",
            "NEGRO",
            "NEGRO BLANCO",
            "NEGRO COMBO",
        ],

        ROJO: [
            "CIRUELA",
            "LADRILLO",
            "ROJO",
            "ROJO AMAPOLA",
            "ROJO CEREZA",
            "ROJO COMBO",
            "ROJO QUEMADO",
            "ROJO TOMATE",
            "VINO",
            "VINO COMBO",
        ],

        ROSA: [
            "BLUSH",
            "BUGAMBILIA",
            "FIUSHA",
            "FIUSHA COMBO",
            "MAGENTA",
            "MARSALA",
            "PALO DE ROSA",
            "ROSA",
            "ROSA BRILLANTE",
            "ROSA COMBO",
            "ROSA NEON",
            "ROSA PASTEL",
            "TURQUESA",
            "TURQUESA BRILLANTE",
        ],

        VERDE: [
            "JADE",
            "MENTA",
            "MENTA COMBO",
            "OLIVO",
            "OLIVO COMBO",
            "SAGE",
            "VERDE",
            "VERDE BOTELLA",
            "VERDE BRILLANTE",
            "VERDE CAZADOR",
            "VERDE CLARO",
            "VERDE COMBO",
            "VERDE LIMA",
            "VERDE MANZANA",
            "VERDE NEON",
            "VERDE OBSCURO",
            "VERDE PASTO",
        ],
    };

    const NOSTO_FACET_DEFINITIONS = [
        {
            field: "skus.customFields.talla",
            type: "values",
            urlParam: "talla",
        },
        {
            field: "customFields.shasa-color",
            type: "values",
            ignored: true,
        },
        {
            field: "customFields.custom-fits",
            type: "values",
            urlParam: "fit",
        },
        {
            field: "customFields.custom-product_group_code",
            type: "values",
            urlParam: "tipo",
        },
        {
            field: "customFields.custom-pg_filtro",
            type: "values",
            urlParam: "group",
        },
        {
            field: "customFields.custom-material",
            type: "values",
            urlParam: "material",
        },
        {
            field: "customFields.custom-color",
            type: "values",
            urlParam: "color",
            isColor: true,
        },
        {
            field: "price",
            type: "range",
        },
    ];
    const NOSTO_FACET_LABELS = {
        "skus.customFields.talla":
            "Talla",

        "customFields.custom-color":
            "Color",

        "customFields.custom-fits":
            "Fit",

        "customFields.custom-product_group_code":
            "Tipo de producto",

        "customFields.custom-pg_filtro":
            "Categoría",

        "customFields.custom-material":
            "Material",

        price:
            "Precio",
    };

    const NOSTO_SIZE_ORDER = [
        "XCH",
        "CH",
        "M",
        "G",
        "XG",
        "CHM",
        "MG",
        "UNITALLA",
        "SIN TALLA",
    ];

    global.NOSTO_COLOR_GROUPS = NOSTO_COLOR_GROUPS;
    global.NOSTO_FACET_DEFINITIONS = NOSTO_FACET_DEFINITIONS;
    global.NOSTO_SIZE_ORDER = NOSTO_SIZE_ORDER;
    global.NOSTO_FACET_LABELS = NOSTO_FACET_LABELS;
})(window);